export const beginAndEndHyphensRegexp = /^(-+)|(-+)$/gi
export const unwantedSymbolsRegexp = /([^a-z0-9-])/gi
export const createNewContactOptionId = 'createNewContactOptionId'
export const createNewContactWithNameOptionId = 'createNewContactWithNameOptionId'
export const createNewContactWithPhoneOptionId = 'createNewContactWithPhoneOptionId'
